import { render, staticRenderFns } from "./overview-of-smoking-area.vue?vue&type=template&id=6dbe1cdb&scoped=true&"
import script from "./overview-of-smoking-area.vue?vue&type=script&lang=js&"
export * from "./overview-of-smoking-area.vue?vue&type=script&lang=js&"
import style0 from "./overview-of-smoking-area.vue?vue&type=style&index=0&id=6dbe1cdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe1cdb",
  null
  
)

export default component.exports